import { createAsyncTypes } from 'utils/ActionCreator'

export const PUSH_NOTIFICATION_REQUEST = createAsyncTypes(
  'PUSH_NOTIFICATION_REQUEST',
  'Settings/ProfileSettings'
)
export const UPDATE_PUSH_NOTIFICATION = createAsyncTypes(
  'UPDATE_PUSH_NOTIFICATION',
  'Settings/ProfileSettings'
)

export const TOGGLE_PUSH_NOTIFICATION = 'Settings/ProfileSettings/TOGGLE_PUSH_NOTIFICATION'
